<template>
  <div>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-1'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-1'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2'
        )
      }}</strong>
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-1'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-1'
          )
        "
      />
      <br /><br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-2'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-2'
          )
        "
      />
      <br /><br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-3'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-3'
          )
        "
      />
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-5'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-5'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-3'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-3'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-4'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-4'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-5'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-5'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-6'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-6'
          )
        "
      />
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
